import axios from 'axios';
import { createContext, useReducer } from 'react';
import { apiNotificationUrl, LOAD_SUCCESS } from '../constants';
import { notificationReducer } from '../reducers/notificationReducer';

export const NotificationContext = createContext();

const NotificationContextProvider = ({ children }) => {
  const [notificationState, dispatch] = useReducer(notificationReducer, {
    notificationLoading: true,
    notification: [],
    pagination: null,
  });

  const getNotification = async (userId, limit, page) => {
    try {
      const response = await axios.get(
        `${apiNotificationUrl}/notifications/${userId}?limit=${limit}&page=${page}`
      );
      if (response?.data) {
        dispatch({
          type: LOAD_SUCCESS,
          payload: {
            notification: response?.data.items,
            page,
            pagination: response?.data.pagination,
          },
        });
      }
      return { success: true, message: 'Get notifications success' };
    } catch (error) {
      dispatch({
        type: LOAD_SUCCESS,
        payload: { notification: [], pagination: null },
      });
      if (error.response?.data) return error.response?.data;
      else return { success: false, message: error.message };
    }
  };

  const notificationContextData = {
    getNotification,
    notificationState,
  };

  return (
    <NotificationContext.Provider value={notificationContextData}>
      {children}
    </NotificationContext.Provider>
  );
};

export default NotificationContextProvider;
